import MComment from './Comment.vue';

export default MComment;
